import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sync',
  templateUrl: './sync.component.html',
  styles: []
})
export class SyncComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
